import { useParams } from 'react-router-dom';
import MaintenanceComponentsDetails from './components/maintenanceComponentsDetails/MaintenanceComponentsDetails';
import MaintenanceComponentsList from './components/maintenanceComponentsList/MaintenanceComponentsList';
import styles from './MaintenanceComponentsTab.module.scss';

const MaintenanceComponentsTab = () => {
    const { type } = useParams<{ type: string, itemId: string }>();

    return <div className={styles.container}>
        {
            (type === 'list' ? <MaintenanceComponentsList /> : <MaintenanceComponentsDetails />)
        }
        </div>;
}

export default MaintenanceComponentsTab;
